import { defineMessages } from 'react-intl'

const globalMessages = defineMessages({
  beds: {
    id: 'room.beds',
  },
})

export default globalMessages
